// extracted by mini-css-extract-plugin
export default {"ScientificDirection":"s_ScientificDirection__iYYRP","results":"s_results__wZLuj"};